/* eslint-disable no-console */
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CyclePicker from '../../../components/Embryology/cyclePicker';
import { CycleData } from '../../../components/Surgery/oocyteRetrieval/OocyteRetrival.helper';
import EmbryoCultureView from './embryoCultureView';
import EmbryoCycleUnavailable from './embryoCycleUnavailable';
import HeaderProfile from '../../../components/header_Profile/header_Profile.index';
import { PatientData } from '../../../types';
import { Box } from '@mui/material';
import { ReactComponent as AIDocInt } from '../../../assets/SVG/ai-doc-int.svg';
import DocumentIntelligencePatientDetail from '../../Ai_Hub/DocumentIntelligence/DocumentIntelligencePatientDetail';
import { theme } from '../../../theme';

const EmbryoCulture: React.FC = () => {
  const [cyclesAvailable, setCyclesAvailable] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState<PatientData | null>(null);

  const [selectedCycle, setSelectedCycle] = useState<CycleData | null>(null);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  // This function will be triggered when a cycle is selected
  const handleCycleChange = useCallback(
    (selectedCycle: CycleData | null) => {
      if (selectedCycle) {
        setSelectedCycle(selectedCycle);
        console.log('Selected Cycle:', selectedCycle);
      } else {
        console.log('No cycle selected');
      }
    },
    []
  );

  const handleOpenDocumentModal = () => {
    if (!selectedPatient?.id) return;
    setShowDocumentModal(true);
  };

  const handleCloseDocumentModal = () => {
    setShowDocumentModal(false);
  };

  useEffect(() => {
    if (!showDocumentModal) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setShowDocumentModal(false);
      }
    };

    window.addEventListener('keydown', handleEsc);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleEsc);
    };
  }, [showDocumentModal]);


  const handleDataFromHeader = (data: PatientData) => {
    setSelectedPatient(data);
  };

  const { t: tCulture } = useTranslation('culture_config');
  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: '12px',
        }}
      >
        <div style={{ flex: 1 }}>
          <HeaderProfile onData={handleDataFromHeader} />
        </div>

        <button
          type="button"
          onClick={handleOpenDocumentModal}
          disabled={!selectedPatient?.id}
          title={selectedPatient?.id ? 'Open patient documents' : 'Select a patient first'}
          aria-label="Open patient documents"
          style={{
            border: 'none',
            background: '#FFFFFF',
            width: '48px',
            height: '48px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: selectedPatient?.id ? 'pointer' : 'not-allowed',
            opacity: selectedPatient?.id ? 1 : 0.5,
            marginTop: '8px',
            marginRight: '16px',
          }}
        >
          <AIDocInt />
        </button>
      </div>
      <Box mt={6} px={2}>
        <CyclePicker onCycleChange={handleCycleChange} onCycleAvailabilityChange={setCyclesAvailable} />
        {cyclesAvailable && selectedPatient ? (
          selectedCycle ? (
            !['(OI) Cycle', 'IUI', 'Surrogacy Cycle'].includes(selectedCycle.procedure.procedures) ? (
              <EmbryoCultureView selectedCycle={selectedCycle} />
            ) : (
              <EmbryoCycleUnavailable noContentMsg={tCulture('notPrescribed', { defaultValue: 'Embryo Culture is not prescribed for selected cycle' })} />
            )
          ) : (
            <p>{tCulture('selectCycle', { defaultValue: 'Select a cycle to view its details.' })}</p>
          )
        ) : (
          <EmbryoCycleUnavailable />
        )}
      </Box>
      {showDocumentModal && selectedPatient?.id && (
        <div
          role="dialog"
          aria-modal="true"
          aria-label="Document Intelligence"
          onClick={handleCloseDocumentModal}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(15, 23, 42, 0.45)',
            backdropFilter: 'blur(4px)',
            zIndex: theme.zIndex.modal,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px',
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: '90vw',
              height: '90vh',
              background: '#fff',
              borderRadius: '20px',
              overflow: 'hidden',
              boxShadow: '0 24px 80px rgba(0,0,0,0.22)',
            }}
          >
            <DocumentIntelligencePatientDetail
              patientId={selectedPatient.id}
              isModal={true}
              onClose={handleCloseDocumentModal}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default EmbryoCulture;
